import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';

import { actions as homeActions } from '~/redux/reducers/home';
import { actions as cityActions } from '~/redux/reducers/city';
import { actions as filterActions } from '~/redux/reducers/filter';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as appActions } from '~/redux/reducers/app';
import { actions as searchActions } from '~/redux/reducers/search';

import HeadTag from '~/components/Head/HeadTag';
// import BannerTopic from '~/components/Row/Topics/BannerTopic';
import Topic from '~/components/Topic/Topic';
import NotFound from '~/components/NotFound/NotFound';
import NotResult from '~/components/Filter/NotResult';
import { Container } from 'tmt-ui-kit';
import Modal from '~/components/Modal/Modal';
import ShareSocials from '~/components/General/ShareSocials/ShareSocials';
import _CustomizeBox from '~/components/Customize/CustomizeBox';
import HistorySection from '~/components/Row/HistorySection';

import { path } from '~/utils/media';
import { thaiCities } from '~/utils/trip';
import { getCity } from '~/utils/helpers';
import { getActivityOptionsFromValues } from '~/utils/filter';
import { isAustralianSite } from '~/utils/region-site-config';
import { pipe } from '~/utils/function';
import headTags from '~/head-tags';
import config from '~/config';

// const TextLocation = Typo.Paragraph.extend`
//   margin: 16px 0 0;
// `;

const BannerTopic = dynamic(
  () => import(/* webpackChunkName: "Topic.BannerTopic.components" */'../../components/Row/Topics/BannerTopic'),
  { loading: () => null }
);

const Breadcrumbs = dynamic(
  () => import(/* webpackChunkName: "Breadcrumbs.Breadcrumbs.components" */'../../components/Breadcrumbs/Breadcrumbs'),
  { loading: () => null }
);

const BreadcrumbsContainer = styled.div`
  @media(max-width: 1200px) {
    display: none;
  }
`;

const CityContainer = styled(Container.InnerContainer)`
  margin-bottom: 40px;
`;

const CustomizeBox = styled(_CustomizeBox)`
  margin-top: 25px;
  display: block;
`;

const checkActivity = (activities = []) => {
  if (activities && activities.length > 1) {
    const actResult = {
      city: 'Bangkok',
      trips: []
    };
    activities.forEach(activity => {
      actResult.trips = actResult.trips.concat(activity.trips);
    });
    return actResult;
  }
  return (activities && activities.length > 0 && activities[0]) || {};
};

const enhance = compose(
  connect(
    state => ({
      cityInfo: state.city.cityInfo,
      activityInfo: state.filter.activityInfo,
      filterInfo: state.filter.filterInfo,
      sessionData: state.session.data,
      isError: state.city.isError,
      userConfig: state.info.userConfig,
      combinedDynamicLoaded: state.info.combinedDynamicLoaded,
      activities: state.filter.activities,
      history: state.search.history,
      rates: state.info.exchangeRates
    }),
    {
      getCity: cityActions.getCity,
      getActivity: filterActions.getActivity,
      setFilterInfo: filterActions.setFilterInfo,
      logFilterActivity: filterActions.logFilterActivity,
      logClickCard: tripActions.logClickCard,
      logImpressCard: tripActions.logImpressCard,
      logImpressTopic: tripActions.logImpressTopic,
      logClickSeeMore: tripActions.logClickSeeMore,
      logScrollEnd: tripActions.logScrollEnd,
      logClickBreakpoint: cityActions.logClickBreakpoint,
      logClickQuiz: homeActions.logClickQuiz,
      getHistory: searchActions.getHistory,
      ...sessionActions,
      ...appActions
    }
  ),
  withRouter
);

const australianWhitelist = ['Bangkok', 'Chiang Mai', 'Hua Hin', 'Kanchanaburi', 'Phuket'];

class CityPage extends Component {
  static propTypes = {
    url: PropTypes.object,
    cityInfo: PropTypes.object,
    activityInfo: PropTypes.array,
    getCity: PropTypes.func,
    isError: PropTypes.bool,
    setFilterInfo: PropTypes.func,
    logFilterActivity: PropTypes.func,
    filterInfo: PropTypes.object,
    getActivity: PropTypes.func,
    activities: PropTypes.array,
    logClickBreakpoint: PropTypes.func,
    getHistory: PropTypes.func,
    history: PropTypes.object,
    rates: PropTypes.object,
    // userConfig: PropTypes.object,
    // combinedDynamicLoaded: PropTypes.bool,
  };

  static async getInitialProps({ store, query, req, res }) {
    const { city, activity } = query;
    try {
      const uppercaseCity = city.split(' ').map(t => (t.length > 0 ? `${t[0].toUpperCase()}${t.substr(1)}` : t)).join(' ');
      let qstr = '';
      if (req && req.url && req.url.match(/\?.+/)) {
        qstr = req.url.match(/\?.+/);
      }
      if (city !== uppercaseCity) {
        res.writeHead(301, { Location: `/to/${uppercaseCity}${qstr}` });
        res.end();
      } else {
        const cityToQuery = isAustralianSite() && australianWhitelist.includes(city) ? `${city}-AU` : city;
        const getCityPromise = store.dispatch(cityActions.getCity(cityToQuery));
        const { data: activities } = await store.dispatch(filterActions.getActivityByCity(city));
        const isActivity = activities && activities.find(c => c === activity);
        const defaultActivity = pipe(
          option => (option ? option.value : undefined)
        )(getActivityOptionsFromValues(activities)[0]);
        const getActivitiesPromise = store.dispatch(filterActions.getActivity(city, isActivity ? activity : defaultActivity));
        await Promise.all([getCityPromise, getActivitiesPromise]);
      }
    } catch (e) {
      if (res) res.statusCode = 404;
    }
    return { };
  }

  state = {
    isOpenShare: false
  }

  async componentDidMount() {
    await this.props.getHistory();
  }

  componentWillUnmount() {
    clearTimeout(this.prefetchTimeout);
  }

  onClickModal = () => {
    this.setState((state) => ({ isOpenShare: !state.isOpenShare }));
  }

  onChangeTopicActivity = async (activity) => {
    const { url, filterInfo } = this.props;
    await this.props.getActivity(url.query.city, activity || 'popular');
    this.props.setFilterInfo({ ...filterInfo, activity });
  }

  getSeeAll = (section) => {
    const { url } = this.props;
    const { link } = section;
    const city = getCity(url.query.city);
    if (link && link.type && link.type !== '') {
      if (link.type === 'city') {
        return `/to/${link.value}`;
      }
      if (link.type === 'type') {
        return `/to/${city}/${link.value}`;
      }
      if (link.type === 'custom') {
        return link.value;
      }
      return null;
    }
    return null;
  }

  render() {
    if (this.props.isError || !this.props.cityInfo) return <NotFound />;
    const { url, filterInfo, history } = this.props;
    // const { useNewFilter } = this.props.userConfig;
    const { section_ids: citySections, banner_image: bannerImg, banner_title: bannerTitle, banner_subtitle: bannerSubtitle, is_hide_filter: isHideFilter } = this.props.cityInfo;
    const location = url.query.city.split('%20').join(' ');
    const title = (headTags && headTags[location]
      && headTags[location].title)
      || `Local day tours in ${location}`;
    const description = (
      headTags
      && headTags[location]
      && headTags[location].description)
      || `Local day tours in ${location || 'Thailand'}`;
    const keywords = headTags
      && headTags[location]
      && headTags[location].keywords
      ? headTags[location].keywords
      : location;
    const ogImage = bannerImg
      ? path(bannerImg, 'featureCover')
      : `${config.baseURL.en}/static/images/Search/mobile-background.jpg`;
    const banner = bannerImg ? {
      image: bannerImg,
      title: bannerTitle,
      subtitle: bannerSubtitle || ''
    } : {
      title: title || '',
    };
    const { trips } = checkActivity(this.props.activityInfo);
    const objActivityInfo = {
      contains: 'filterTrips',
      trip_ids: trips || []
    };
    const hasBreakpoint = (citySections.filter(c => c.contains === 'breakpoint')).length || 0;
    const isShowFilter = thaiCities.includes(location) && objActivityInfo.trip_ids && !isHideFilter;
    return (
      <div>
        <HeadTag
          title={title}
          description={description}
          keywords={keywords}
          siteName={`TakeMeTour - ${title}`}
          image={ogImage}
        />
        {banner && (
          <div className="banner-container">
            <BannerTopic
              url={url}
              objects={banner}
              location={location}
              isOpen={this.onClickModal}
              activities={this.props.activities}
              setFilterInfo={this.props.setFilterInfo}
              logFilterActivity={this.props.logFilterActivity}
              filterInfo={filterInfo}
              hasBreakpoint={hasBreakpoint}
              logClickBreakpoint={this.props.logClickBreakpoint}
              useNewFilter
            />
          </div>
        )}
        <CityContainer>
          <div className="page-container">
            {!banner && (
              <div className="banner-container">
                <BannerTopic location={location} objects={banner} isOpen={this.onClickModal} isNavbar/>
              </div>
            )}
            {/* <h1>
              {(headTags[location] && headTags[location].h1) ||
                `Local day tours in ${location}`}
            </h1>} */}
            <BreadcrumbsContainer>
              <Breadcrumbs type="City" data={{ city: location }} />
            </BreadcrumbsContainer>
            {/* <TextLocation>{headTags[location] ? headTags[location].sub_header : banner.subtitle}</TextLocation> */}
            {history && Array.isArray(history.trip_ids) && history.trip_ids.length > 0 && (
              <div key="history-data">
                <HistorySection
                  {...this.props}
                  name="Recently Viewed"
                  objects={history.trip_ids}
                  fullPath={url.query.fullPath}
                />
              </div>
            )}
            {isShowFilter && (
              <div>
                <Topic
                  {...this.props}
                  topic={objActivityInfo}
                  reloadFilterTrips={(activity) => this.onChangeTopicActivity(activity)}
                  index={0}
                />
                {objActivityInfo.trip_ids.length <= 0 && <NotResult />}
              </div>
            )}
            {citySections.map((topic, index) => (
              <Topic
                {...this.props}
                key={`topic-${index}`}
                topic={topic}
                reloadAvailableTrips={(date) => this.props.getCity(url.query.city, date)}
                index={index}
              />
            ))}
          </div>
          {isAustralianSite() && <CustomizeBox baseURL={config.baseURL.au} />}
        </CityContainer>
        <Modal isOpen={this.state.isOpenShare} onClose={this.onClickModal}>
          <ShareSocials />
        </Modal>
      </div>
    );
  }
}

export default enhance(CityPage);
